export default "__VITE_ASSET__kcvikcEh__"